import cx from "classnames";
import React from "react";
import { CMS_ASSET_URL_BASE } from "../../../../config";
import styles from "./ByOpponent.module.scss";
import { useHistory } from "react-router-dom";
import { adobeClickTracking } from "../../../../helpers/tracking";
import { useSelector } from "react-redux";
import { routePath } from "../../../../helpers/urlPathMapping";
import { differenceInCalendarDays } from "date-fns";

const LeagueBox = ({ league, teams }) => {
  const history = useHistory();
  const { type } = useSelector((state) => state.singleGroup);
  const gamesType = type === "single" ? "Single Game" : "Group";
  const prop13 = `Washington Nationals: Tickets: Nationals Ticketfinder: ${gamesType} Tickets: By Opponent`;
  const activeHandler = (team) => {
    if (team.active) {
      if (team.last_game_date) {
        // console.log(
        //   "differenceInCalendarDays",
        //   team.name,
        //   team.last_game_date,
        //   differenceInCalendarDays(new Date(team.last_game_date), new Date()) +
        //     1
        // );
        return (
          differenceInCalendarDays(new Date(team.last_game_date), new Date()) +
            1 >=
          0
        );
      } else {
        return team.active;
      }
    } else {
      return team.active;
    }
  };
  if (!league || !teams) return;

  return (
    <div className={styles.leagueBox}>
      <div className={styles.title}>
        <h2>{league}</h2>
      </div>
      <div className={styles.teamWrapper}>
        {teams
          .sort((a, b) => (a.name > b.name ? 1 : -1))
          .map(
            (team) =>
              team.alias !== "washington-nationals" && (
                <div
                  key={team.name}
                  className={cx(
                    styles.team,
                    activeHandler(team) || styles.disable
                  )}
                  onClick={() => {
                    adobeClickTracking({
                      prop13,
                      prop14: `${gamesType} Tickets: By Opponent: ${team.name} Click`,
                    });
                    history.push(routePath(type).GAMES_BY_OPPONENT.path, {
                      data: team.alias,
                    });
                  }}
                >
                  <img
                    src={`${CMS_ASSET_URL_BASE}${team.logo?.path}`}
                    alt="team logo"
                    className={styles.logo}
                  />
                  <div className={styles.name}>
                    <h3>{team.name}</h3>
                  </div>
                  <img
                    className={styles.arrow}
                    src={require("../../../../assets/images/icons/icon-arrow-opponent.svg")}
                    alt=""
                  />
                </div>
              )
          )}
      </div>
    </div>
  );
};

export default LeagueBox;
